// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/img/dust_scratches.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#vod-activePivot {
  border-bottom: 3px solid orange;
}
.vod-selectPivots {
  cursor: pointer;
}
.vod-helpPivots {
  display: flex;
  justify-content: space-evenly;
  font-family: "Amatic SC Bold";
  font-size: 2vw;
  font-weight: 900;
}
.vod-icon-transButtons-help {
  display: grid;
  height: 2.2vw;
  width: 100%;
}
.vod-transButtons-help {
  display: grid;
  column-gap: 1vw;
  row-gap: 0.5vw;
  justify-self: center;
  grid-template-columns: repeat(3, 3.4vw);
}
.vod-closeButton {
  position: absolute;
  top: 1%;
  left: 1%;
  height: 2.5vw;
  cursor: pointer;
}
.vod-iconhelp {
  height: 2vw;
  place-content: center;
}

.vod-next-help {
  filter: brightness(0.8);
}
#vod-modesCards {
  direction: rtl;
  overflow: auto;
  height: 95%;
}
.vod-helpPanel {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 31vw;
  padding: 1.5%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  box-shadow:
    0 4px 8px rgba(0, 0, 0, 0.2),
    0 6px 20px rgba(0, 0, 0, 0.19);
  z-index: 2;
}
.vod-helpCard {
  position: relative;
  direction: ltr;
  padding: 1vw;
  margin: 1.25vw;
  width: auto;
  border: solid 1px #1a6a7c;
  border-radius: 10px;
  background: #ffffff;
  filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.4));
  font-size: 1.5vw;
}
.vod-cardCaption {
  font-family: "Amatic SC Bold";
  font-size: 2vw;
}
.vod-auxButtonshelp {
  display: grid;
  width: 50%;
  grid-template-columns: repeat(3, auto);
  gap: 0.5vw;
  justify-self: center;
}
#vod-modesCards::-webkit-scrollbar {
  width: 0.5vw;
}

#vod-modesCards::-webkit-scrollbar-thumb {
  background: #cecece;
}`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Vodyanoy/styles/helppanel.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,eAAe;AACjB;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,cAAc;EACd,WAAW;AACb;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,WAAW;EACX,aAAa;EACb,yDAAgE;EAChE;;kCAEgC;EAChC,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EAEnB,mDAAmD;EACnD,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,aAAa;EACb,UAAU;EACV,sCAAsC;EACtC,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["#vod-activePivot {\n  border-bottom: 3px solid orange;\n}\n.vod-selectPivots {\n  cursor: pointer;\n}\n.vod-helpPivots {\n  display: flex;\n  justify-content: space-evenly;\n  font-family: \"Amatic SC Bold\";\n  font-size: 2vw;\n  font-weight: 900;\n}\n.vod-icon-transButtons-help {\n  display: grid;\n  height: 2.2vw;\n  width: 100%;\n}\n.vod-transButtons-help {\n  display: grid;\n  column-gap: 1vw;\n  row-gap: 0.5vw;\n  justify-self: center;\n  grid-template-columns: repeat(3, 3.4vw);\n}\n.vod-closeButton {\n  position: absolute;\n  top: 1%;\n  left: 1%;\n  height: 2.5vw;\n  cursor: pointer;\n}\n.vod-iconhelp {\n  height: 2vw;\n  place-content: center;\n}\n\n.vod-next-help {\n  filter: brightness(0.8);\n}\n#vod-modesCards {\n  direction: rtl;\n  overflow: auto;\n  height: 95%;\n}\n.vod-helpPanel {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 31vw;\n  padding: 1.5%;\n  background-image: url(../../../../public/img/dust_scratches.png);\n  box-shadow:\n    0 4px 8px rgba(0, 0, 0, 0.2),\n    0 6px 20px rgba(0, 0, 0, 0.19);\n  z-index: 2;\n}\n.vod-helpCard {\n  position: relative;\n  direction: ltr;\n  padding: 1vw;\n  margin: 1.25vw;\n  width: auto;\n  border: solid 1px #1a6a7c;\n  border-radius: 10px;\n  background: #ffffff;\n  -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.4));\n  filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.4));\n  font-size: 1.5vw;\n}\n.vod-cardCaption {\n  font-family: \"Amatic SC Bold\";\n  font-size: 2vw;\n}\n.vod-auxButtonshelp {\n  display: grid;\n  width: 50%;\n  grid-template-columns: repeat(3, auto);\n  gap: 0.5vw;\n  justify-self: center;\n}\n#vod-modesCards::-webkit-scrollbar {\n  width: 0.5vw;\n}\n\n#vod-modesCards::-webkit-scrollbar-thumb {\n  background: #cecece;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
